module.exports = __webpack_public_path__ + "static/media/32.7e89173d.jpg";